import { S3_BASE_URL } from 'constants/static';
import styled from 'styled-components';

export const Overlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 430px;
  height: 100dvh;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.3);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  transition: opacity 0.3s ease;

  @media (min-width: 1024px) {
    max-width: 600px;
  }
`;

export const OverlayInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const LoginContainer = styled.aside<{ $isOpen: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 430px;
  background: #fff;
  z-index: 999;
  display: flex;
  flex-direction: column;
  box-shadow: ${({ $isOpen }) => ($isOpen ? '-2px 0 8px rgba(0,0,0,0.1)' : 'none')};
  transform: translate3d(${({ $isOpen }) => ($isOpen ? '0' : '100%')}, 0, 0);
  transition: transform 0.3s ease;
  will-change: transform;

  @media (min-width: 1024px) {
    max-width: 600px;
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 40px 24px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
`;

export const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 28px;
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 800;
  color: #0f0f0f;
  line-height: 140%;
  text-align: center;
  margin: 0;
  height: 42px;
  flex-shrink: 0;
`;

export const FormSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 15px;
  color: #0f0f0f;
  font-weight: 400;
  line-height: 20px;
`;

export const PhoneInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const PhoneNumberRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CountrySelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const CountrySelect = styled.div<{ $disabled?: boolean }>`
  padding: 12px 40px 12px 16px;
  font-weight: 400;
  border: 1px solid #d2d3d6;
  border-radius: 4px;
  background-color: ${({ $disabled }) => ($disabled ? '#EAEBEF' : '#ffffff')};
  font-size: 15px;
  color: ${({ $disabled }) => ($disabled ? '#B6BCBF' : '#2c2c2c')};
  outline: none;
  font-weight: 400;
  line-height: 140%;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url('${S3_BASE_URL}/down_gray_arrow.svg');
  background-repeat: no-repeat;
  background-position: right 12px center;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
`;

export const DropdownList = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #d9dfed;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
`;

export const DropdownItem = styled.div<{ $selected: boolean }>`
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 400;
  line-height: 140%;
  cursor: pointer;
  background-color: ${(props) => (props.$selected ? '#D4EA2F' : '#ffffff')};
  color: #0f0f0f;

  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

export const PhoneInput = styled.input<{ $disabled?: boolean }>`
  flex: 1;
  height: 48px;
  padding: 12px 16px;
  border-radius: 4px;
  background-color: ${({ $disabled }) => ($disabled ? '#EAEBEF' : '#ffffff')};
  font-size: 14px;
  color: ${({ $disabled }) => ($disabled ? '#B6BCBF' : '#2c2c2c')};
  outline: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};

  &::placeholder {
    color: #b6bcbf;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const FullWidthInput = styled.input<{ $disabled?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 12px 16px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 15px;
  color: #2c2c2c;
  outline: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};

  &::placeholder {
    color: #b6bcbf;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const SendCodeButton = styled.button`
  width: 129px;
  height: 48px;
  padding: 12px 16px;
  background-color: #002400;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  &:disabled {
    background-color: #eaebef;
    color: #b6bcbf;
    cursor: not-allowed;
  }
`;

export const CodeInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CodeInput = styled.input<{ $disabled?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 12px 60px 12px 16px;
  border: 1px solid #d9dfed;
  border-radius: 4px;
  background-color: ${({ $disabled }) => ($disabled ? '#EAEBEF' : '#ffffff')};
  font-size: 14px;
  color: ${({ $disabled }) => ($disabled ? '#B6BCBF' : '#2c2c2c')};
  outline: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};

  &::placeholder {
    color: #b6bcbf;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const Timer = styled.span`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #999999;
  pointer-events: none;
`;

export const VerifyButton = styled.button<{ $disabled: boolean }>`
  position: static;
  transform: none;
  width: 100%;
  height: 48px;
  border-radius: 4px;
  border: none;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ $disabled }) => ($disabled ? '#B6BCBF' : '#ffffff')};
  background: ${({ $disabled }) => ($disabled ? '#EAEBEF' : '#002400')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const Checkbox = styled.input`
  display: flex;
  width: 18px;
  height: 18px;
  margin: 3px 0 0 0;
  border-radius: 4px;
  accent-color: #003507;
  background-color: #ffffff;
  flex-shrink: 0;
`;

export const CheckboxLabel = styled.label`
  font-size: 16px;
  color: #0f0f0f;
  font-weight: 400;
  line-height: 24px;

  a {
    color: #2a27e1;
    text-decoration: underline;
  }
`;

export const StepContainer = styled.div<{ $show: boolean }>`
  display: ${(props) => (props.$show ? 'flex' : 'none')};
  width: 100%;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 14px 24px;
`;

export const ForgotPasswordContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const ForgotPasswordButton = styled.button`
  background: transparent;
  border: none;
  color: #1c60ff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-family: 'Plus Jakarta Sans';
  text-decoration-style: solid;
`;
